import React, { useEffect } from "react";
import { useContactForm, FormState } from "../../hooks/useContactForm";

export const ContactForm = ({ onSuccess }) => {
  const {
    values,
    touched,
    errors,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
    state,
  } = useContactForm();

  useEffect(() => {
    if (state === FormState.Success) {
      onSuccess();
    }
  }, [onSuccess, state]);

  return (
    <>
      <h4 className="modal-container-title">Comunicate con nosotras</h4>
      <p className="modal-container-text">
        Completá el formulario con tus datos y la consulta o comentario que
        desees realizarnos. Te responderemos a la brevedad.
      </p>
      <form
        onSubmit={handleSubmit}
        autoComplete="off"
        className="form-container"
      >
        <div className="form-option">
          <label htmlFor="name">Nombre y apellido</label>{" "}
          {errors.name && touched.name && (
            <span className="form-option-validation">{errors.name}</span>
          )}
          <input
            type="text"
            name="name"
            id="name"
            placeholder="Ingresá tu nombre y apellido"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.name}
            className={errors.name && touched.name ? "input-error" : ""}
          />
        </div>
        <div className="form-option">
          <label htmlFor="email">Correo electrónico</label>{" "}
          {errors.email && touched.email && (
            <span className="form-option-validation">{errors.email}</span>
          )}
          <input
            type="text"
            name="email"
            id="email"
            placeholder="Ingresá tu dirección de e-mail"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email}
            className={errors.email && touched.email ? "input-error" : ""}
          />
        </div>
        <div className="form-option">
          <label htmlFor="phone">Teléfono{<span>(Opcional)</span>}</label>
          <input
            type="text"
            name="phone"
            id="phone"
            placeholder="Ingresá tu número telefónico"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.phone}
          />
        </div>
        <div className="form-option">
          <label htmlFor="message">Mensaje</label>{" "}
          {errors.message && touched.message && (
            <span className="form-option-validation">{errors.message}</span>
          )}
          <textarea
            name="message"
            id="message"
            placeholder="Ingresá tu consulta o comentario"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.message}
            className={errors.message && touched.message ? "input-error" : ""}
          ></textarea>
        </div>
        <div className="form-btn-container">
          {state === FormState.Error && (
            <p className="message-error">
              Falló el envío del mensaje, intentá nuevamente en unos segundos.
            </p>
          )}
          {state === FormState.Sending && (
            <p className="message-error">
              Enviando el mensaje, esperá unos segundos.
            </p>
          )}
          <input
            disabled={isSubmitting}
            type="submit"
            value="Enviar mensaje"
            className="btn-send"
          />
        </div>
      </form>
    </>
  );
};
